import { ImgCaseStudyAtMyCasaCover, ImgCaseStudyChargeawayCover, ImgCaseStudyCozmoGearzCover, ImgCaseStudyCozmoPlanToolCover, ImgCaseStudyGlowyCover, ImgCaseStudyLower6Cover, LogoDvekrestRounded, gdrdevelopmenetframeimage } from "@/lib/images";
import { StaticImageData } from "next/image";

export interface CaseStudy {
    id: string;
    companyName: string;
    /** Optional document title override for CaseStudyMeta. */
    pageTitle?: string;
    title: string;
    logo: StaticImageData;
    industry: string;
    challenge: string;
    solution: string[];
    result: string;
    duration: string;
    category: string;
    coverImage: StaticImageData;
    link: string;
    metaDescription: string;
    isHero?: boolean;
}

export const caseStudies: CaseStudy[] = [
    {
        id: "cs11",
        companyName: "Glowy",
        pageTitle: "Skincare Routine Mobile App Development — Glowy Case Study | Devkrest",
        title: "A personalized skincare companion for routines and progress tracking.",
        logo: LogoDvekrestRounded,
        industry: "Skincare & Beauty",
        challenge: "Users struggled to build consistent skincare routines and track what actually worked for their skin. They needed a simpler, more personalized way to manage habits, monitor progress, and stay engaged.",
        solution: ["Flutter", "UX/UI Design", "Community Features"],
        result: "95% user retention, 4.8 star app store rating",
        duration: "15 mins read",
        category: "Mobile App",
        coverImage: ImgCaseStudyGlowyCover,
        link: "/case-studies/skincare-routine-mobile-app",
        metaDescription:
            "Devkrest built Glowy — a Flutter skincare routine app with a routine builder, progress tracker, and creator dashboard. See how we turned a concept into a fully-launched product in 8 weeks.",
        isHero: true
    },
    {
        id: "cs12",
        companyName: "CaloriePal",
        pageTitle: "AI Food Recognition Mobile App Development — CaloriePal Case Study | Devkrest",
        title: "CaloriePal — Vision AI Food Recognition & Health Tracking App",
        logo: LogoDvekrestRounded,
        industry: "Fitness & Health",
        challenge: "Creating an AI-powered mobile app for instant food recognition and real-time glycemic analysis to help healthcare professionals and patients monitor health effectively",
        solution: ["React Native", "Vision AI", "Real-time Analytics", "Cross-Platform Development"],
        result: "Trusted by healthcare professionals, seamless food tracking experience",
        duration: "15 mins read",
        category: "Mobile App",
        coverImage: ImgCaseStudyLower6Cover,
        link: "/case-studies/vision-ai-ml-recognition-mobile-app",
        metaDescription:
            "Devkrest built CaloriePal — a React Native AI health app with Vision AI food recognition, real-time glycemic tracking, and personalized insights. Delivered in 12 weeks on iOS and Android.",
        isHero: false
    },

    {
        id: "cs1",
        companyName: "Cozmo Gearz",
        pageTitle: "Custom CRM Development for Health Insurance — Cozmo Gearz Case Study | Devkrest",
        title: "A custom CRM and AI software suite for health insurance teams.",
        logo: LogoDvekrestRounded,
        industry: "CRM & AI",
        challenge: "Health insurance teams were relying on disconnected tools and slow manual workflows to serve clients. They needed one system that could centralize operations, speed up quoting, and support agents more efficiently.",
        solution: ["Aircall Integration", "Call Routing", "Analytics Dashboard"],
        result: "45% faster response time, 30% increase in CSAT",
        duration: "12 mins read",
        category: "Custom CRM",
        coverImage: ImgCaseStudyCozmoGearzCover,
        link: "/case-studies/custom-crm-health-insurance",
        metaDescription:
            "Devkrest built Cozmo Gearz — a custom CRM and AI software platform for health insurance agents. 15 modules, 30+ active agents, and a 40% average revenue boost. See how we built it in 1.5 years.",
        isHero: true
    },
    {
        id: "cs13",
        companyName: "Cozmo Plan Finder Tool",
        title: "An AI-powered plan finder for faster insurance selection.",
        logo: LogoDvekrestRounded,
        industry: "Healthcare",
        challenge: "Insurance agents were spending too long comparing plans across carriers, which created delays and slowed sales. The process needed to be faster, more accurate, and easier to tailor by region and business priorities.",
        solution: ["AI Algorithm", "CMS Integration", "Real-time Analytics", "Automated Comparisons"],
        result: "90% faster search time, 50% sales increase, 80% reduced wait times",
        duration: "12 mins read",
        category: "Custom CRM - Sales",
        coverImage: ImgCaseStudyCozmoPlanToolCover,
        link: "/case-studies/ai-based-insurance-plan-finder-solution",
        metaDescription: "See how Devkrest created the Cozmo Plan Finder Tool, an AI-powered solution that reduced insurance plan search time by 90% and increased sales by 50%.",
        isHero: true
    },
    {
        id: "cs14",
        companyName: "ChargeAway",
        pageTitle: "EV Charging Mobile App Development Case Study: ChargeAway | Devkrest",
        title: "A mobile app that simplifies EV charging and route planning.",
        logo: LogoDvekrestRounded,
        industry: "Electric Vehicles",
        challenge: "EV drivers had difficulty finding reliable charging stations and planning trips with confidence. They needed a simple mobile experience with clear station details, real-time updates, and smoother route planning.",
        solution: ["Mobile App", "Real-time Tracking", "Payment Integration", "Route Planning"],
        result: "25,000+ downloads projected, 4.2+ star rating, 1,000+ stations mapped",
        duration: "18 mins read",
        category: "Mobile App",
        coverImage: ImgCaseStudyChargeawayCover,
        link: "/case-studies/ev-charging-solution",
        metaDescription:
            "Devkrest built ChargeAway, a Flutter EV charging app with real-time station availability, route planning, integrated payments, and a home charger hosting network. The client came back for a second project.",
        isHero: false
    },
    // {
    //     id: "cs15",
    //     companyName: "Signit",
    //     pageTitle: "Custom Digital Signing Platform Development Case Study: Signit | Devkrest",
    //     title: "A document signing platform that reduces manual work.",
    //     logo: LogoDvekrestRounded,
    //     industry: "CRM",
    //     challenge: "Document signing workflows were too manual, slow, and repetitive for teams handling frequent approvals. The platform needed to reduce effort, speed up turnaround times, and simplify the entire process.",
    //     solution: ["AI-powered document signing", "Automated document signing", "Document signing automation"],
    //     result: "25% faster document signing, 30% reduction in manual effort, 40% increase in efficiency",
    //     duration: "12 mins read",
    //     category: "SaaS",
    //     coverImage: ImgCaseStudySignitCover,
    //     link: "/case-studies/custom-digital-signing-platform",
    //     metaDescription:
    //         "Devkrest built Signit, a custom e-sign platform handling 6,000 daily documents. It cuts signing costs by 70% versus DocuSign, with CRM integration, multi-signer support, and enterprise-grade encryption.",
    //     isHero: false
    // },
    // {
    //     id: "cs18",
    //     companyName: "GDR Development",
    //     title:
    //         "GDR Development — Building a modern software and CRM foundation to manage projects, teams, and client relationships with clarity.",
    //     logo: LogoDvekrestRounded,
    //     industry: "Real Estate & Development",
    //     challenge:
    //         "GDR Development needed a clearer, more connected way to manage daily operations, projects, and client communication. Spreadsheets and disconnected tools were slowing the team down and making it difficult to get a complete picture of what was happening across the business.",
    //     solution: [
    //         "Custom internal dashboard for pipeline and projects",
    //         "Lightweight CRM for tracking deals and relationships",
    //         "Integrations to reduce manual data entry"
    //     ],
    //     result:
    //         "In progress – we’re documenting how a more connected system simplifies decisions, reduces friction, and gives the team a single source of truth.",
    //     duration: "Coming soon",
    //     category: "Custom CRM",
    //     coverImage: ImgCaseStudyCozmoGearzCover,
    //     link: "/case-studies/real-estate-crm-development",
    //     metaDescription:
    //         "Coming soon: how Devkrest helped GDR Development replace scattered tools with a modern software and CRM foundation for their growing business.",
    //     isHero: false,
    // },

    {
        id: "cs16",
        companyName: "AtMyCasa",
        title: "A social dining platform for local culinary experiences.",
        logo: LogoDvekrestRounded,
        industry: "Event Hosting",
        challenge: "The platform needed to help hosts and guests connect through trusted local dining experiences. It also required a smooth way to discover events, manage bookings, and build community engagement.",
        solution: [
            "Host and event management",
            "Seamless booking system",
            "Direct messaging between hosts and guests"
        ],
        result: "Enabled hosts to monetize their culinary skills, boosted guest engagement with local dining events, and helped expand cultural connections through food experiences.",
        duration: "15 mins read",
        category: "Event Hosting",
        coverImage: ImgCaseStudyAtMyCasaCover,
        link: "/case-studies/event-hosting-solution",
        metaDescription: "Learn how Devkrest built AtMyCasa, a social dining platform connecting food lovers with local hosts for unique cultural and culinary experiences.",
        isHero: false
    },

    // {
    //     id: "cs17",
    //     companyName: "Enroll.Health",
    //     title: "A modern health insurance platform with a clearer digital journey.",
    //
    //     logo: LogoDvekrestRounded,
    //     industry: "Health Insurance",
    //     challenge: "Users needed a clearer and more trustworthy way to explore health insurance options online. The experience had to simplify comparisons, explain benefits better, and guide decisions with more confidence.",
    //     solution: [
    //         "Host and event management",
    //         "Seamless booking system",
    //         "Direct messaging between hosts and guests"
    //     ],
    //     result: "Enabled hosts to monetize their culinary skills, boosted guest engagement with local dining events, and helped expand cultural connections through food experiences.",
    //     duration: "15 mins read",
    //     category: "Health Insurance",
    //     coverImage: ImgCaseStudyEnrollHealthCover,
    //     link: "/case-studies/health-insurance-website-platform",
    //     metaDescription: "Redesigning the platform to bring clarity transparency, and confidence to health insurance decisions. The new experience focuses on clear information,guided flows,and a smoother journey that helps users compare plans, understand benefits, and choose with ease.",
    //     isHero: false
    // },
    {
        id: "cs19",
        companyName: "GDR Development",
        title:
            "A modern software and CRM foundation for connected operations.",
        logo: LogoDvekrestRounded,
        industry: "Real Estate & Development",
        challenge:
            "Daily operations, projects, and client communication were spread across disconnected tools and manual processes. The team needed a more connected system with better visibility and easier day-to-day coordination.",
        solution: [
            "Custom internal dashboard for pipeline and projects",
            "Lightweight CRM for tracking deals and relationships",
            "Integrations to reduce manual data entry"
        ],
        result:
            "In progress – we’re documenting how a more connected system simplifies decisions, reduces friction, and gives the team a single source of truth.",
        duration: "10 mins read",
        category: "Custom CRM",
        coverImage: gdrdevelopmenetframeimage,
        link: "/case-studies/real-estate-crm-development",
        metaDescription:
            "Coming soon: how Devkrest helped GDR Development replace scattered tools with a modern software and CRM foundation for their growing business.",
        isHero: false,
    },
];

export const industries = [
    "All Industries",
    "SaaS",
    "Healthcare",
    "E-commerce",
    "Finance",
    "Fintech",
    "Education",
    "Energy",
    "Travel",
    "Media",
    "Retail",
    "Data Analytics",
    "Health & Beauty",
    "Electric Vehicles",
    "CRM & AI",
    "Event Hosting",
    "Skincare & Beauty",
    "Fitness & Health"
];

export const categories = [
    "All Categories",
    "Customer Story",
    "Digital Transformation",
    "Mobile Development",
    "Security",
    "Cloud Infrastructure",
    "IoT",
    "Web Development",
    "Performance Optimization",
    "E-commerce",
    "AI & Machine Learning",
    "Mobile App",
    "Custom CRM",
    "Custom CRM - Sales"
]; 